import React, { useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useToast } from '@unite-us/app-components';
import ListItem from './components/ListItem';
import './group-selector.scss';

const GroupSelector = ({ groups, setGroupId }) => {
  const { addToast } = useToast();

  const selectGroup = useCallback((id = '') => {
    setGroupId(id);
  }, [setGroupId]);

  useEffect(() => {
    const licensedGroups = groups.filter(({ group }) => group.licensed);

    if (licensedGroups.length === 1) {
      selectGroup(licensedGroups[0].group.id);
    } else if (licensedGroups.length < 1) {
      addToast({
        type: 'error',
        message: 'User does not belong to any valid organizations',
    });
    }
  }, [groups, selectGroup, addToast]);

  const groupListItems = groups
    .filter(({ group }) => (group.licensed))
    .map((group) => (
      <ListItem
        group={group.group}
        key={group.group.id}
        setGroupId={selectGroup}
      />
    ));

  return (
    <div className="group-selector">
      <div className="group-selector__header">
        <h1>
          {groupListItems.length > 0 ? 'Please Select a Group' : 'No groups'}
        </h1>
      </div>
      <div className="group-selector__choices">
        {groupListItems}
      </div>
    </div>
  );
};

GroupSelector.propTypes = {
  groups: PropTypes.array.isRequired,
  setGroupId: PropTypes.func.isRequired,
};

export default GroupSelector;
